export default function meetingArchive() {
    document.querySelectorAll('.meeting-archive').forEach(initBlock);
}

function initBlock(section) {
    const blockId   = section.dataset.blockId;
    const resultsEl = document.getElementById(`meeting-results-${blockId}`);
    const searchForm = section.querySelector('.meeting-archive__search');

    if (!resultsEl) return;

    resultsEl.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-page]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        const page   = parseInt(btn.dataset.page, 10);
        const search = searchForm
            ? (searchForm.querySelector('input[name="meeting_search"]')?.value ?? '')
            : '';
        loadResults(section, resultsEl, page, search, true);
    });

    if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const search = searchForm.querySelector('input[name="meeting_search"]')?.value ?? '';
            loadResults(section, resultsEl, 1, search);
        });
    }
}

async function loadResults(section, resultsEl, page, search, scrollToTop = false) {
    const nonce    = section.dataset.nonce;
    const settings = section.dataset.settings;
    const ajaxUrl  = window.mxAjax?.url;

    if (!ajaxUrl) return;

    resultsEl.classList.add('is-loading');
    resultsEl.setAttribute('aria-busy', 'true');

    try {
        const body = new URLSearchParams({
            action:   'meeting_archive_load',
            nonce,
            settings,
            paged:    page,
            search,
        });

        const response = await fetch(ajaxUrl, { method: 'POST', body });
        const json = await response.json();

        if (json.success && json.data?.html) {
            resultsEl.innerHTML = json.data.html;

            // Announce the update to screen readers via the persistent
            // status element (a live region injected with the results
            // would not be announced reliably).
            const statusEl = section.querySelector('.meeting-archive__status');
            if (statusEl) {
                const pagination = resultsEl.querySelector('[data-total-pages]');
                statusEl.textContent = pagination
                    ? `Meetings updated. Page ${pagination.dataset.paged} of ${pagination.dataset.totalPages}.`
                    : 'Meetings updated.';
            }

            if (scrollToTop) {
                // The clicked pagination button was just replaced, so move
                // focus to the results container to keep keyboard users in
                // the block. preventScroll leaves scrolling to scrollTo below.
                resultsEl.focus({ preventScroll: true });
                // Scroll the top of the block (search bar included) to just
                // below the fixed header. getBoundingClientRect().bottom on
                // the header also accounts for the WP admin bar offset.
                // Deferred a frame so the position is measured after the new
                // results have laid out and the browser's own scroll
                // adjustments (anchoring/clamping) have already happened.
                requestAnimationFrame(() => {
                    const target = section.querySelector('.meeting-archive__search') ?? section;
                    const headerBottom = document.querySelector('.header-nav')?.getBoundingClientRect().bottom ?? 0;
                    const top = target.getBoundingClientRect().top + window.scrollY - headerBottom - 16;
                    window.scrollTo({ top, behavior: 'smooth' });
                });
            } else {
                resultsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }
    } catch (err) {
        console.error('Meeting archive load failed:', err);
    } finally {
        resultsEl.classList.remove('is-loading');
        resultsEl.removeAttribute('aria-busy');
    }
}
